import React from 'react'
import { Row, Col } from 'react-bootstrap'
import {
    Table,
} from 'react-bootstrap'
import defaultImg from '../../../../../../assets/images/no-img-found.png'
import 'react-day-picker/lib/style.css';


export default function ListingTable(props) {
    const { lines,
        //  sale_order_no, setSaleOrderNo, terms,setTerms,
        comments, setComment, staffNotes, setStaffNotes } = props

    let total = 0
    lines.forEach(line => {
        total = total + (line.quantity || 0) * (line.variant_price || (line.price || 0))
    });

    return (

        <React.Fragment>

            {/* <ListingTableTopBar/> */}
            <div className="st-listing-table mt-2">
                <Table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>Product/Service</th>
                            <th>Qty</th>
                            <th>Item Price</th>
                            <th>Item Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lines.filter(e => e.product_name).map((line, index) => {
                            return <tr key={index}>
                                <td className="w-50 ">
                                    <div className="d-flex align-items-center">
                                        <img src={defaultImg} alt="product" />
                                        <div>{line.product_name}<br />
                                            {line.variant_sku}</div>
                                    </div>
                                </td>
                                <td>
                                    {line.quantity || 1}
                                </td>
                                <td>{line.variant_price || line.price}</td>
                                <td>
                                    {((line.quantity || 0) * (line.variant_price || (line.price || 0))) || (line.variant_price || line.price)}
                                </td>
                            </tr>
                        })}

                        {/* <tr>
                            <td>
                                <img src={defaultImg} alt="product" />
                                [Sample] Fog Linen Chambray Towel - Beige Stripe...
                            </td>
                            <td>0</td>
                            <td>0.00</td>
                            <td>0.00</td>
                        </tr>
                        */}
                    </tbody>
                </Table>
            </div>

            <div className="comment-and-note">
                <h5>Comments and Notes</h5>
                <Row>
                    <Col>
                        <div className="d-flex align-items-top justify-content-between">
                            <label>Comments</label>
                            <textarea
                                className="form-control"
                                placeholder="Visible to vendor"
                                id="comments"
                                value={comments}
                                cols="30"
                                rows="3"
                                type="text"
                                onChange={(e) => { setComment(e.target.value) }}
                            />
                        </div>
                    </Col>
                    <Col>
                        <div className="d-flex align-items-top justify-content-between">
                            <label>Staff Notes</label>
                            <textarea
                                className="form-control"
                                placeholder="Visible to staff"
                                id="comments"
                                value={staffNotes}
                                cols="30"
                                rows="3"
                                type="text"
                                onChange={(e) => { setStaffNotes(e.target.value) }}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}
